import React from 'react';

import { useTranslation } from '@framework/hooks';
import { redirectToAuthenticatedPath } from '@framework/utils/redirect';

import ContentBox from '@accounts/components/layout/ContentBox/ContentBox';
import AdditionalActions from '@accounts/components/ui/AdditionalActions/AdditionalActions';
import ContentBoxTitle from '@accounts/components/ui/ContentBoxTitle/ContentBoxTitle';
import GetHelpAction from '@accounts/components/ui/GetHelpAction/GetHelpAction';
import SherpanyTopLogo from '@accounts/components/ui/SherpanyTopLogo/SherpanyTopLogo';
import useIsNativeApps from '@accounts/hooks/useIsNativeApps';

import { Button } from 'styled-system';

import styles from './LoginSuccessPrompt.module.scss';

const LoginSuccessPrompt = () => {
    const { t } = useTranslation();
    const isNativeApps = useIsNativeApps();

    return (
        <ContentBox>
            <SherpanyTopLogo />
            <ContentBoxTitle title={t('Login successful')} />
            <div className={styles.actions}>
                <Button htmlType="button" onClick={redirectToAuthenticatedPath}>
                    {t('Continue')}
                </Button>
            </div>
            {!isNativeApps && (
                <AdditionalActions>
                    <GetHelpAction />
                </AdditionalActions>
            )}
        </ContentBox>
    );
};

export default LoginSuccessPrompt;
